import React from 'react';

import Heading from '@atlaskit/heading';
import { Text } from '@atlaskit/primitives';

const Summary = ({ accountsMapping }) => {
  const {
    created_at,
    metadata: { created_by_user = {} } = {},
    pagerduty: {
      account_base_url = ''
    } = {},
  } = accountsMapping || {};

  const userName = created_by_user.name || created_by_user.jira_displayname || created_by_user.pd_displayname || 'Unknown user';
  const userUrl = created_by_user.url || created_by_user.jira_html_url || created_by_user.pd_html_url || '#';

  const connectionDate = new Date(Date.parse(created_at));

  return (
    <div>
      <Heading size="small">Summary</Heading>
      <table>
        <tbody style={{ border: 'none' }}>
          <tr>
            <td><Text weight="semibold" color="color.text.subtlest">Accounts connected at:</Text></td>
            <td>{created_at ? connectionDate.toLocaleString() : 'Unknown time'}</td>
          </tr>
          <tr>
            <td><Text weight="semibold" color="color.text.subtlest">PagerDuty Account:</Text></td>
            <td><a href={account_base_url} target="_blank" rel="noopener noreferrer">{account_base_url}</a></td>
          </tr>
          <tr>
            <td><Text weight="semibold" color="color.text.subtlest">Accounts connected by:</Text> </td>
            <td><a href={userUrl} target="_blank" rel="noopener noreferrer">{userName}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Summary;
